import React from 'react'

const FunnelChart = ({ data, isLoading}) => {

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-[200px] w-full">
                <div className="mini-spinner mt-3"></div>
            </div>
        );
    }

    if (!isLoading && data.length === 0) {
        return (
            <div className="flex items-center justify-center h-[200px] w-full">
                No data available
            </div>
        );
    }

    return (
        <>
            <div className="flex justify-start items-center flex-col mt-10 h-[350px] overflow-y-auto">
                {data && data.length > 0 && data.map((item, index) => (
                    <div key={index} className="flex items-center gap-4 mb-[3px] w-full">
                        <div className="w-[25%] text-right pr-5 text-[14px] truncate">
                            {item.stage}
                        </div>
                        {/* <div className='w-[5%]'></div> */}
                        <div className="w-[60%] flex justify-center h-[35px]">
                            <div
                                style={{ width: `${item.width}%`, 'minWidth': '15%', 'backgroundColor': `${item.color}` }} className={`bg-blue-500 text-white text-center rounded h-[35px] flex items-center justify-center`}>
                                {item.width}%
                            </div>
                        </div>
                        {/* <div className='w-[5%]'></div> */}
                        <div className="w-[15%] text-left pl-5 text-[14px]">
                            {item.count}
                        </div>
                    </div>
                ))}
                {data && data.length === 0 && (
                    <div className="flex items-center justify-center h-[200px] w-full">
                        No data available</div>
                )}

                {isLoading && (
                    <div className="flex items-center justify-center h-[200px] w-full">
                        Loading...</div>
                )}
            </div>
        </>
    )
}

export default FunnelChart;